export default __webpack_public_path__ + "static/media/fb.d9288460.svg";